import { buttonVariants } from '@/components/ui/button';
import { GradientStarIcon } from '@/assets/icons/GradientStarIcon';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export function NewDesignBanner({ link }: { link: string }) {
  const { t } = useTranslation();

  return (
    <div className="w-full items-center justify-between px-10 py-2.5 bg-gradient-to-r from-secondary-purple-P100 via-slate-50 to-primary-blue-B100 hidden md:flex">
      <div className="flex items-center gap-2 text-sm font-medium text-gray-800">
        <GradientStarIcon />
        <span>{t('general.navigation.newDesignBanner')}</span>
      </div>
      <a
        href={link}
        className={cn(
          buttonVariants({
            size: 'sm',
            variant: 'outline-secondary',
          }),
          'font-normal',
        )}>
        {t('general.navigation.zumClassicDesign')}
      </a>
    </div>
  );
}
